import {
  EventDispatcher,
} from 'three';
import io from 'socket.io-client';
import { SCENE_EVENTS } from '../components/MVC/Model';
import { SCENE_INTERACTION } from '../constants/scene';
import { WEBRTC_EVENTS } from '../constants/webrtc';
import ScreenShareRequestNotification from '../components/WebRTC/ScreenShareRequestNotification';
import $ from 'jquery';
import { GLOBAL_EVENTS } from '../constants/global';
import { GAME_EVENTS } from '../constants/game';
import { initGravitec } from '../components/OneSignal/Gravitec';
import { filterSocketItems } from '../components/Chat/chatData';
import { handleRestriction } from './socketHelper';
import { SocketTour, tourID } from './SocketTour';
import { EMOTION_EVENTS } from '../components/engine/tour/EmotionEvents';
import { SOCKET_EVENTS } from './Events';
import { getImgThumb } from '../components/engine/helpers/getImageType';
import { actions, isPageEmbedded } from '../components/engine/helpers/ui-logic';
import { TRACK_EVENTS } from '../components/engine/constants/track';
import { ICON } from "../components/Icons/Icons";
import { DeltaUpdateManager, SmoothCameraRenderer, TourUpdateManager } from './Manager/managers';
import { stringToHslColor } from '../components/engine/helpers/colors';
import { ANT_MEDIA_SERVER_BAGELSS_EVENTS } from '../components/WebRTC/constants';
export { SOCKET_EVENTS };

let _socket;
let local = true;

// Socket reconnection timeout in milliseconds
const RECONNECT_TIMEOUT = 1000;

let messages = [];
let allUsermessages = {};

let globalMessages = [];
let tourMessages = [];
let privateMessages = {};
let localMessages = {};
let chessMessages = {};
export let userHistory = {};

export const addChessMessage = (payload, type) => {
  const id = payload.receiverId;
  if (!chessMessages[id]) {
    chessMessages[id] = [];
  }
  chessMessages[id].push({
    type, payload
  });
};
export const addGlobalMessage = (payload, type) => {
  const id = payload.senderId;
  globalMessages.push({
    type, payload
  });
};

export const addPrivateMessage = (payload, type, toSave) => {
  let id = payload.senderId;
  if (toSave) {
    id = toSave;
  }
  if (!privateMessages[id]) {
    privateMessages[id] = [];
  }
  privateMessages[id].push({
    type, payload
  });
};
export const addTourMessage = (payload, type) => {
  tourMessages.push({
    type, payload
  });
};
export const addLocalMessage = (payload, type) => {
  const id = payload.receiverId;
  if (!localMessages[id]) {
    localMessages[id] = [];
  }
  localMessages[id].push({
    type, payload
  });
};

export const getLocalRoomMessages = () => {
  return localMessages
};
export const getGlobalMessages = () => {
  return globalMessages
};
export const getPrivateMessages = () => {
  return privateMessages
};
export const getTourMessages = () => {
  return tourMessages
};
export const getChessMessages = () => {
  return chessMessages
};

export let userProperties = {};

class Socket extends EventDispatcher {

  _currentUserData = {};
  onlineFriends = [];


  constructor({ model, CONFIG }) {
    super();
    this.callbacks = [];
    this.forcedReload = false;
    this.model = model;
    model.setSocket(this);
    this.mouseData = {
      x: 0,
      y: 0
    };

    // Initialize tour performance managers
    this.tourUpdateManager = new TourUpdateManager();
    this.deltaUpdateManager = new DeltaUpdateManager();
    this.smoothCameraRenderer = new SmoothCameraRenderer();

    this.chessGames = {};

    // Set up smooth rendering callback for your camera system
    this.smoothCameraRenderer.setRenderCallback((position, rotation) => {
      if (this.model && this.model.camera) {
        this.model.camera.position.set(...position);
        this.model.camera.rotation.set(...rotation);
        this.model.camera.updateProjectionMatrix();
        if (this.model.view && this.model.view.updateShphereTextureOnMove) {
          this.model.view.updateShphereTextureOnMove();
        }
      }
    });

    userProperties = {
      currentUserMood: 1,
      sceneId: null,
      addImageUrl: this.model.config.addImageUrl,
      email: null,
      hasProfile: this.model.config.wpId,
      sessionId: this.model.config.sessionId,
      socketUrl: this.model.config.socketUrl,
      temporaryFileUploadUrl: this.model.config.temporaryFileUploadUrl,
      userAvatarUrl: this.model.config.userAvatarUrl,
      userId: this.model.config.userId,
      plan: this.model.config.subscriptionPlan.plan.id,
      userName: this.model.config.userName,
      // userVideoOn: this.model.config.userVideoOn || false,
      userVideoOn: true,
      userScreenShareOn: false,
      objId: null,
      wordpressEditProfileUrl: this.model.config.wordpressEditProfileUrl,
      worldId: this.model.config.worldId,
      sceneName: 'Scene 1 - World 1',
      audioLevels: 0,
      oneSignalAppId: null,
      webcamStreamId: null,
      screenStreamId: null,
      on1on1Call: false,
      socketId: null,
      actions: actions,
    };

    model.addEventListener(SCENE_INTERACTION.LOCK_SCENE, (e) => {
      this._userLockingRoom(userProperties.userId, userProperties.currentSceneId);
    });
    model.addEventListener(SCENE_INTERACTION.UNLOCK_SCENE, (e) => {
      this._userLockingRoom("0", userProperties.currentSceneId);
    });

    model.addEventListener(SCENE_INTERACTION.NEW_SCENE_INITIALISED, (e) => {
      this.model.onSceneInitialised({ senderId: userProperties.userId }, this._currentUserData)
    });
    model.addEventListener(SCENE_INTERACTION.USER_TAKES_SEAT, (e) => {
      this._userChangingSeat(userProperties.userId, e.data.id, userProperties.webcamStreamId)
    });
    model.addEventListener(SCENE_INTERACTION.USER_TAKES_SCREEN_SHARE_SEAT, (e) => {
      this._userChangingScreenShareSeat(userProperties.userId, e.data.id, userProperties.webcamStreamId)
    });

    model.addEventListener(SCENE_INTERACTION.USER_LEAVES_SEAT, (e) => {
      this._userChangingSeat("0", e.data.id, null);
      this.model.dispatchEvent({ type: SCENE_EVENTS.SOMEONE_CHANGED_DATA, data: this._currentUserData });
    });
    model.addEventListener(SCENE_INTERACTION.USER_LEAVES_SCREEN_SHARE, (e) => {
      this._userChangingScreenShareSeat("0", e.data.id, null);
      this.model.dispatchEvent({ type: SCENE_EVENTS.SOMEONE_CHANGED_DATA, data: this._currentUserData });
    });
    model.addEventListener(SCENE_INTERACTION.USER_TAKES_SCREEN, (e) => {
      this._userChangingScreen(userProperties.userId, e.data.id, userProperties.screenStreamId)
    });
    model.addEventListener(SCENE_INTERACTION.USER_STOP_SCREEN, (e) => {

      let userId = null;
      if (e.data.userId != null) {
        userId = e.data.userId;
      } else {
        userId = userProperties.userId;
      }
      this._userChangingScreen(userId, e.data.dbConig.id, null);
      this.model.dispatchEvent({ type: SCENE_EVENTS.SOMEONE_CHANGED_DATA, data: this._currentUserData });
    });
    model.addEventListener(SCENE_INTERACTION.NEW_USER_ON_PUBLIC_STAGE, (e) => {
      if (this.model.guestJoinedPublicStage) {
        this.model.dispatchEvent({ type: WEBRTC_EVENTS.SOMEONE_JOINED_PUBLIC_STAGE, data: this._currentUserData });
      }
    });

    model.addEventListener(SCENE_EVENTS.SCENE_DATA_RECIEVED, (e) => {

    });

    model.addEventListener(SCENE_EVENTS.ONE_ON_ONE_CHAT, (e) => {
      const item = e.item;
      this.dispatchEvent({ type: SOCKET_EVENTS.ADD_ONE_ON_ONE_CHAT, data: item });
    });

    model.addEventListener(SCENE_EVENTS.ENVIRONMENT_CHANGED, (e) => {
      const { roomId } = e.data;
      self._send({
        eventName: 'environmentChanged',
        senderId: userProperties.userId,
        roomId
      });
    });

    model.addEventListener(SCENE_INTERACTION.USER_MOOD_CHANGED, function (e) {
      userProperties.currentUserMood = e.data.mood; // {mood} = e.data ||| userProperties.currentUserMood = int(1..3) initially

      if (self._currentUserData[userProperties.userId]) {
        self._currentUserData[userProperties.userId].currentUserMood = e.data.mood;
      }

      self._send({
        eventName: 'userMoodChanged',
        senderId: userProperties.userId,
        data: {
          newMood: userProperties.currentUserMood,
        },
      });
    });



    model.addEventListener(SCENE_INTERACTION.USER_SCREEN_SHARE_STATE_CHANGED, (e) => {
      if (self._currentUserData[e.data.userId]) {
        self._currentUserData[e.data.userId].objId = e.data.objId;
        self._currentUserData[e.data.userId].userScreenShareOn = e.data.userScreenShareOn;
      }

      self._send({
        eventName: 'userScreenShareStateChanged',
        senderId: e.data.userId,
        data: {
          userScreenShareOn: e.data.userScreenShareOn,
          objId: e.data.objId
        },
      });

    });


    model.addEventListener(SCENE_INTERACTION.USER_SCENE_CHANGED, (e) => {
      userProperties.sceneId = e.data.sceneID;
      const name = this.model.getSceneNameFromId(e.data.sceneID);
      if (self._currentUserData[userProperties.userId]) {
        self._currentUserData[userProperties.userId].sceneId = e.data.sceneID;
        self._currentUserData[userProperties.userId].currentSceneId = e.data.sceneID;
        self._currentUserData[userProperties.userId].currentSceneName = e.data.currentSceneName || this.model.getSceneNameFromId(e.data.sceneID);
      }
      self._joinScene(e.data.sceneID, name);
      this.dispatchEvent({ type: SOCKET_EVENTS.USER_DATA_CHANGED, data: this._currentUserData });
      const { lockedRooms } = this._currentUserData;
      if (lockedRooms) {
        Object.keys(lockedRooms).forEach(key => {
          if (lockedRooms[key] === e.data.sceneID) {
            this.model.lockScene();
          }
        })
      }
    });

    model.addEventListener(WEBRTC_EVENTS.REQUEST_SCREEN_SHARE, (e) => {
      self._send({
        eventName: 'request_shareScreen',
        senderId: userProperties.userId,
        data: {
          userId: e.data.ownerId,
          scopeId: e.data.scopeId,
          scopeName: e.data.scopeName,
          objID: e.data.objID,
        },
        senderInfo: {
          id: userProperties.userId,
          name: userProperties.userName,
          avatar_url: userProperties.userAvatarUrl
        }
      });

    });

    model.addEventListener(WEBRTC_EVENTS.WEBRTC_USER_STARTED_SCREEN_SHARE, (e) => {
      const { scopeType, withCamera, withSound, scopeId, scopeDisplayName, peerInfo, userScreenShareOn, screenStreamId } = e.data;

      // if (e.data.screenStreamId !== null) {
      if (e.data.screenStreamId) {
        userProperties.screenStreamId = e.data.screenStreamId;
        const data = {};
        data.screenStreamId = e.data.screenStreamId;
        this.updateUserData(data);
      }

      self._send({
        eventName: 'userChangedScreen',
        senderId: userProperties.userId,
        data: {
          withCamera,
          withSound,
          scopeId,
          scopeDisplayName,
          peerInfo,
          userScreenShareOn: e.data.userScreenShareOn,
          objId: e.data.unique_id,
          screenId: e.data.unique_id,
          screenStreamId: e.data.screenStreamId
        },

      });
    });

    model.addEventListener(WEBRTC_EVENTS.WEBRTC_USER_STARTED_VIDEO, (e) => {
      const { scopeType, withCamera, withSound, scopeId, scopeDisplayName, peerInfo } = e.data;

      if (scopeType === 'users') {
        self._send({
          eventName: 'videoOneOnOne_request',
          senderId: userProperties.userId,
          data: {
            withCamera,
            withSound,
            scopeId,
            scopeDisplayName,
            peerInfo
          },
          senderInfo: {
            id: userProperties.userId,
            name: userProperties.userName,
            avatar_url: userProperties.userAvatarUrl
          }
        });
      }
      if (scopeType === 'screenShare') {
        self._send({
          eventName: 'userChangedScreen',
          senderId: userProperties.userId,
          data: {
            userScreenShareOn: true,
            objId: e.data.objId,
          },

        });
      }
    });

    model.addEventListener(WEBRTC_EVENTS.WEBRTC_SCREEN_APPROVED, (e) => {
      const { callInitiatorID, scopeId, objID } = e.data;
      self._send({
        eventName: 'approved_shareScreen',
        senderId: userProperties.userId,
        data: {
          callInitiatorID,
          scopeId,
          objID
        }
      });
    });

    model.addEventListener(WEBRTC_EVENTS.WEBRTC_SCREEN_DENIED, (e) => {
      const { callInitiatorID, scopeId } = e.data;
      self._send({
        eventName: 'denied_shareScreen',
        senderId: userProperties.userId,
        data: {
          callInitiatorID,
          scopeId,
        }
      });
    });

    model.addEventListener(WEBRTC_EVENTS.WEBRTC_I_STOP_BROADCASTING, (e) => {
      this.model.dispatchEvent({ type: SCENE_EVENTS.SOMEONE_CHANGED_DATA, data: this._currentUserData });
    });

    model.addEventListener(WEBRTC_EVENTS.WEBRTC_CALL_REJECTED, (e) => {
      const { callInitiatorID, scopeId } = e.data;
      self._send({
        eventName: 'videoOneOnOne_reject',
        senderId: userProperties.userId,
        data: {
          callInitiatorID,
          scopeId,
        }
      });
    });

    model.addEventListener(WEBRTC_EVENTS.WEBRTC_CALL_CANCELED, (e) => {
      const { classToBeRemoved } = e.data;
      self._send({
        eventName: 'videoOneOnOne_cancel',
        senderId: userProperties.userId,
        data: {
          classToBeRemoved
        }
      });
    });

    model.addEventListener(SCENE_INTERACTION.USER_AVATAR_CHANGED, (e) => {
      const data = {};

      if (e.data.hasOwnProperty('userName')) {
        data.userName = e.data.userName;
        userProperties.userName = e.data.userName;
      }

      if (e.data.hasOwnProperty('userAvatarUrl')) {
        data.userAvatarUrl = e.data.userAvatarUrl;
        userProperties.userAvatarUrl = e.data.userAvatarUrl;

        self._send({
          eventName: 'userAvatarChanged',
          senderId: userProperties.userId,
          data: { ...data, userId: userProperties.userId }
        });
      }

      this.updateUserData(data);
    });

    model.addEventListener(GLOBAL_EVENTS.CHECK_OWNER_STATUS, (e) => {
      const userId = e.userId;
      setTimeout(() => {
        self._send({
          eventName: 'checkOwnerStatus',
          senderId: userProperties.userId,
          data: {
            userId
          }
        });
      }, 1000); // allowed some time for senderId to be ready
    });

    model.addEventListener(GAME_EVENTS.JOIN_LOBBY, (e) => {
      const { gameId, status, gameData } = e.data;
      self._send({
        eventName: 'userJoinGame',
        userId: userProperties.userId,
        gameId,
        gameData,
        data: {
          userId: userProperties.userId,
          userName: userProperties.userName,
          userAvatarUrl: userProperties.userAvatarUrl,
          status
        }
      });
    });

    model.addEventListener(GAME_EVENTS.NEW_PLAYER, (e) => {
      const { gameId, status, playerData } = e.data;
      self._send({
        eventName: 'updateGameUserStatus',
        userId: userProperties.userId,
        gameId,
        status,
        playerData
      });
    });

    model.addEventListener(GAME_EVENTS.GAME_READY, (e) => {
      if (!e.data) {
        return;
      }
      const { gameId, property, value } = e.data;
      self._send({
        eventName: 'updateGameStatus',
        userId: userProperties.userId,
        gameId,
        property,
        value
      });
    });

    this.addEventListener(SOCKET_EVENTS.USER_DATA_CHANGED, () => {
      model.syncButtonNavUI()
    });

    let socket;
    let self = this;

    this.initRoom = (roomConfig) => {
      roomConfig.currentSceneName = "rooms";
      roomConfig.currentSceneId = 0;
      roomConfig.creatorUserIdOfWorld = 0;
      roomConfig.url = window.location.href;

      socket = io(roomConfig['socketUrl'], {
        transports: ['websocket', 'polling'],
        query: roomConfig,
      });
    }

    this.init = (webConfig) => {
      let _config;
      if (webConfig) {
        _config = webConfig;
        userProperties.sceneId && (_config.currentSceneId = userProperties.sceneId);
        userProperties.sceneId && (_config.sceneId = userProperties.sceneId);
        userProperties.worldName = this.model.sceneData.name;
        _config.worldName = userProperties.worldName;
        _config.isEmbed = isPageEmbedded();
      }

      _config.currentSceneName = this.model.getCurrentSceneName();
      _config.currentSceneId = this.model.currentScene.id;
      _config.userMicOn = true;
      _config.creatorUserIdOfWorld = this.model.sceneData.creatorUserIdOfWorld;
      _config.url = window.location.href;

      userProperties = {
        ...userProperties,
        ..._config,
      }

      socket = io(_config['socketUrl'], {
        transports: ['websocket', 'polling'],
        query: _config,
      });

      this.socketTour = new SocketTour({ socket, model, engineSocket: this });

      this.callbacks.map(item => {
        socket.on(item.id, (payload) => {
          item.func(payload) && item.func(payload)(payload)
        });
      })

      socket.on('connect_error', (err) => {
        this.model.dispatchEvent({ type: SOCKET_EVENTS.SOCKET_CONNECT_ERROR, data: err });
      });

      socket.on('connect', () => {
        this.model.info('success', "Connected to online services");
        setTimeout(() => {
          this.model.info('success', "Loading online users...");
        }, 500)
        userProperties.socketId = socket.id;
      });

      socket.on('initialized', () => {
        socket.initialized = true
        this.model.dispatchEvent({ type: SOCKET_EVENTS.SOCKET_CONNECT_SUCCESS });
        this.initialised = true;
        socket.emit('client_ready');
      })

      handleRestriction(socket, this.model);

      let isWindowReloading = false
      window.addEventListener("beforeunload", () => {
        isWindowReloading = true
      });

      socket.on('disconnect', (reason) => {
        this.initialised = false;
        if (reason !== 'io client disconnect') {
          this.model.alert('success', "Online services error");
          this.model.info('success', "Reconnecting to online services");
        }

        if (this.forcedReload) {
          this.cleanUpData()

        } else if (!this.model?.isFrozenSession) {
          this.reconnectTimer = setTimeout(() => {
            if (!isWindowReloading) {
              socket.connect();
            }
          }, RECONNECT_TIMEOUT);
        }
        this.model.dispatchEvent({ type: SOCKET_EVENTS.DISCONNECT });
      });

      socket.on('socket-availability-error', (payload) => {
        if (payload.value === 'run-unlimited-tours') {
          this.model.socket.socketTour.onStopTourNow();
        }
        this.model.dispatchEvent({
          type: SOCKET_EVENTS.FEATURE_AVAILABILITY_ERROR,
          data: payload
        });
      });

      this.ignoredInfoTypes = ["userAudioLevelsChanged",];
      socket.on('message', (payload) => {
        const data = payload;
        if (payload.eventName && !this.ignoredInfoTypes.includes(payload.eventName)) {
          (console.log(`%c ${payload.eventName} `, `color:${stringToHslColor(payload.eventName, 100, 70)}; background: black; font-weight:bold`));
        }
        if (payload.eventName === "chatMessage") {
          if (payload.receiverType === "room") {
            addGlobalMessage(payload, "recieved");
            data.messages = messages;
            this.dispatchEvent({ type: SOCKET_EVENTS.MESSAGE_RECEIVED, data: data });
          }
          if (payload.receiverType === "user") {
            addPrivateMessage(payload, "recieved");
            data.messages = allUsermessages[data.senderId];
            this.dispatchEvent({ type: SOCKET_EVENTS.ONE_ONE_ONE_MESSAGE_RECEIVED, data });
          }
          if (payload.receiverType === "tour") {
            addTourMessage(payload, "recieved");
            this.dispatchEvent({ type: SOCKET_EVENTS.TOUR_MESSAGE_RECEIVED, data });
          }
          if (payload.receiverType === "local") {
            addLocalMessage(payload, "recieved");
            this.dispatchEvent({ type: SOCKET_EVENTS.LOCAL_MESSAGE_RECEIVED, data });
          }
          if (payload.receiverType === "chess") {
            addChessMessage(payload, "recieved");
            this.dispatchEvent({ type: SOCKET_EVENTS.CHESS_MESSAGE_RECEIVED, data });
          }
          if (payload.receiverType === "lockRequest") {
            this.model.lockRequestUser = data;
            this.model.dispatchEvent({ type: SOCKET_EVENTS.REQUEST_RECEIVED, data });
          }
          if (payload.receiverType === "acceptLockRequest") {
            this.model.dispatchEvent({ type: SOCKET_EVENTS.REQUEST_ACCEPTED, data });
          }
        }
        try {
          switch (payload.eventName) {
            case 'currentUsers':
              if (payload.data[userProperties.userId]) {
                userProperties = { ...userProperties, ...payload.data[userProperties.userId] }
              }
              userHistory = payload.data;
              filterSocketItems(userHistory)
              this._currentUserData = payload.data || {};
              this._currentUserData.occupiedSeats = payload.occupiedSeats;
              if (payload.screenShareOccupiedSeats) {
                this._currentUserData.screenShareOccupiedSeats = payload.screenShareOccupiedSeats;
              }
              for (let [key, value] of Object.entries(this._currentUserData)) {
                if (value.userScreenShareOn) {
                  var obj = {};
                  obj[value.objId] = value.userId;
                  this._currentUserData.occupiedScreens = obj;
                }
              }
              //// HERE create inital lockedRooms on user connects and connect with VRScebeChangeObject
              this.model.onSceneInitialised(payload, this._currentUserData);
              // this.dispatchEvent({ type: SOCKET_EVENTS.USER_DATA_CHANGED, data: this._currentUserData });
              this.initUsers = true;
              this.dispatchEvent({ type: SOCKET_EVENTS.INIT_USERS });
              this.model.worldFetcher.sendTrack({ event: TRACK_EVENTS.ENTER_ROOM, ...payload })
              break;
            case 'chatMessage':

              break;
            case 'sessionConnected':
              userHistory[payload.data.userId] = payload.data;
              filterSocketItems(userHistory)
              this._currentUserData[payload.data.userId] = payload.data;

              this.dispatchEvent({ type: SOCKET_EVENTS.USER_DATA_CHANGED, data: this._currentUserData });
              this.model.dispatchEvent({ type: SCENE_EVENTS.SOMEONE_JOINED_ROOM, data: payload.data });
              // $j('body').trigger('aptis-user-connected', [payload.data || {}]);
              break;
            case 'sessionDisconnected':
              this.model.socketUserDisconnected(this._currentUserData[payload.data.userId]);
              this.model.friends.online = this.model.friends.online.filter((user) => user.userId !== payload.data.userId);
              if (this._currentUserData[payload.data.userId]) {
                this._currentUserData[payload.data.userId].userScreenShareOn = payload.data.userScreenShareOn ? payload.data.userScreenShareOn : false;
                this._currentUserData[payload.data.userId].objId = payload.data.objId ? payload.data.objId : null;
                if (!payload.data.userScreenShareOn) {
                  for (const key in this._currentUserData.occupiedScreens) {
                    if (this._currentUserData.occupiedScreens[key] == payload.senderId) {
                      this._currentUserData.occupiedScreens[key] = null;
                    }
                  }
                }
              }
              if (this._currentUserData[payload.data.userId]) {
                delete this._currentUserData[payload.data.userId];
              }
              this.dispatchEvent({ type: SOCKET_EVENTS.USER_DATA_CHANGED, data: this._currentUserData });
              this.dispatchEvent({ type: SOCKET_EVENTS.USER_DISCONNECTED, data: this._currentUserData[payload.data.userId] || payload.data || {} });
              break;
            case 'sceneJoined':
              this.dispatchEvent({ type: SOCKET_EVENTS.USER_LEFT_SCENE, payload });
              if (this._currentUserData[payload.senderId]) {
                this._currentUserData[payload.senderId].currentSceneId = payload.data.sceneId || '';
                this._currentUserData[payload.senderId].currentSceneName = payload.data.sceneName || this.model.getSceneNameFromId(payload.data.sceneId) || '';
                this.dispatchEvent({ type: SOCKET_EVENTS.USER_JOINED_SCENE, data: payload });

                this.model.worldFetcher.sendTrack({ event: TRACK_EVENTS.LOCATION_CHANGE, ...payload })
              }
              break;

            case 'sessionConnected_global':
              const { userId, isGuest } = model.config;
              if (userId && !isGuest) {
                initGravitec(userId, this.model)
              }
              this.model.dispatchEvent({ type: GLOBAL_EVENTS.SESSION_CONNECTED, data: payload.data });
              this.requestFriendsInfo();
              break;
            case 'sessionDisconnected_global':
              this.requestFriendsInfo();
              break;

            case 'userMoodChanged':
              if (this._currentUserData[payload.senderId]) {
                this._currentUserData[payload.senderId].currentUserMood = payload.data.newMood ? payload.data.newMood.toString() : 1;
              }
              this.dispatchEvent({ type: SOCKET_EVENTS.USER_DATA_CHANGED, data: this._currentUserData });
              this.model.dispatchEvent({ type: SCENE_EVENTS.SOMEONE_CHANGED_DATA, data: this._currentUserData });
              break;

            case 'userMoodChanged_global':
              if (this._currentUserData[payload.senderId]) {
                this._currentUserData[payload.senderId].currentUserMood = payload.data.newMood ? payload.data.newMood.toString() : 1;
              }
              this.model.dispatchEvent({ type: GLOBAL_EVENTS.MOOD_CHANGED, data: payload });
              break;

            case 'userVideoStateChanged':
              if (this._currentUserData[payload.senderId]) {
                this._currentUserData[payload.senderId].userVideoOn = payload.data.userVideoOn;
                this._currentUserData[payload.senderId].on1on1Call = payload.data.on1on1Call ? payload.data.on1on1Call : false;
                this._currentUserData[payload.senderId].webcamStreamId = payload.data.webcamStreamId ? payload.data.webcamStreamId : this._currentUserData[payload.senderId].webcamStreamId;
              }
              this.model.dispatchEvent({ type: SOCKET_EVENTS.USER_VIDEO_STATE_CHANGED, data: this._currentUserData });
              $(".localVideoWrapper").hasClass('focus-mode') && $("#active-focused-element").val() === `video_${payload.senderId}` && $(".focused_element").toggleClass('hidden', !payload.data.userVideoOn);
              break;
            case 'userMicrophoneStateChanged':
              if (this._currentUserData[payload.senderId]) {
                this._currentUserData[payload.senderId].userMicOn = payload.data.userMicOn;
              }
              this.model.dispatchEvent({ type: SOCKET_EVENTS.USER_MICROPHONE_STATE_CHANGED });
              break;

            case 'userScreenShareStateChanged':
              if (this._currentUserData[payload.senderId]) {
                this._currentUserData[payload.senderId].userScreenShareOn = payload.data.userScreenShareOn;
                this._currentUserData[payload.senderId].objId = payload.data.objId;

                if (!payload.data.userScreenShareOn) {
                  this._currentUserData[payload.senderId].screenStreamId = null;
                  for (const key in this._currentUserData.occupiedScreens) {
                    if (this._currentUserData.occupiedScreens[key] == payload.senderId) {
                      this._currentUserData.occupiedScreens[key] = null;
                    }
                  }
                }
              }
              this.dispatchEvent({ type: SOCKET_EVENTS.USER_DATA_CHANGED, data: this._currentUserData });
              this.model.dispatchEvent({ type: SCENE_EVENTS.SOMEONE_CHANGED_DATA, data: this._currentUserData });
              break;
            case 'userChangedScreen':
              if (payload.data) {
                if (this._currentUserData[payload.senderId]) {
                  this._currentUserData[payload.senderId].userScreenShareOn = payload.data.userScreenShareOn ? payload.data.userScreenShareOn : false;
                  this._currentUserData[payload.senderId].objId = payload.data.objId ? payload.data.objId : null;
                  this._currentUserData[payload.senderId].screenId = payload.data.screenId;
                  this._currentUserData[payload.senderId].screenStreamId = payload.data.screenStreamId;
                }
                if (payload.data.objId && payload.senderId) {
                  let senderId = payload.senderId;
                  let objId = payload.data.objId;
                  var obj = {};
                  obj[objId] = senderId;
                  this._currentUserData.occupiedScreens = obj;
                }
              }
              this.model.setOccupiedScreen(payload, this._currentUserData);
              this.dispatchEvent({ type: SOCKET_EVENTS.USER_DATA_CHANGED, data: this._currentUserData });
              break;

            case 'userAudioLevelsChanged':
              if (this._currentUserData[payload.senderId]) {
                this._currentUserData[payload.senderId].audioLevels = payload.data.newAudioLevels ? payload.data.newAudioLevels : 0;
              }
              this.model.dispatchEvent({ type: SCENE_EVENTS.SOMEONE_SPOKE, data: this._currentUserData });
              break;

            case 'request_shareScreen':
              if (payload.data.userId == this.model.config.userId) {
                new ScreenShareRequestNotification({ data: payload.data, senderInfo: payload.senderInfo, requestToShareScreenText: $trans('requests-to-share-screen-text') });
              }
              break;

            case 'approved_shareScreen':
              if (payload.data.callInitiatorID === userProperties.userId) { // not needed, let as double check
                this.model.dispatchEvent({ type: WEBRTC_EVENTS.YOUR_SCREEN_APPROVED, data: payload.data });
              }
              break;

            case 'denied_shareScreen':
              if (payload.data.callInitiatorID === userProperties.userId) { // not needed, let as double check
                this.model.dispatchEvent({ type: WEBRTC_EVENTS.YOUR_SCREEN_DENIED, data: payload.data });
              }
              break;

            case 'videoOneOnOne_request':
              if (payload.data.peerInfo && (payload.data.peerInfo.userId === userProperties.userId)) { // not needed, let as double check
                this.model.notificationToBeShownToUser = { data: payload.data, senderInfo: payload.senderInfo, isCallingYouText: $trans('is-calling-you-text') };
                // new IncomingCallNotification({ data: payload.data, senderInfo: payload.senderInfo, isCallingYouText: $trans('is-calling-you-text') });
              }
              break;

            case 'videoOneOnOne_reject':
              if (payload.data.callInitiatorID === userProperties.userId) { // not needed, let as double check
                this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_SOMEONE_REJECTED_YOUR_CALL, data: payload.data });
              }
              this.model.hideLoading();
              break;

            case 'videoOneOnOne_cancel':
              this._removeNotification(payload.data.classToBeRemoved);
              this.model.dispatchEvent({ type: WEBRTC_EVENTS.WEBRTC_SOMEONE_REJECTED_YOUR_CALL, data: payload.data });
              this.model.hideLoading();
              break;

            case 'checkOwnerStatus':
              this.model.dispatchEvent({ type: GLOBAL_EVENTS.OWNER_STATUS, data: payload.data });
              break;

            case 'userAvatarChanged':
              if (payload.data && payload.data.userId && payload.data.userAvatarUrl) {
                this._currentUserData[payload.data.userId] = { ...this._currentUserData[payload.data.userId], ...payload.data }
              }
              this.model.dispatchEvent({ type: GLOBAL_EVENTS.AVATAR_CHANGED, data: payload });
              break;

            case 'possibleCallInitiatorOrReceiverGotDisconnected':
              const classToBeRemoved = `video_notification_from_${payload.senderId}`;
              this._removeNotification(classToBeRemoved);
              this.model.dispatchEvent({ type: GLOBAL_EVENTS.SESSION_DISCONNECTED, id: payload.senderId });
              break;

            case 'userDataUpdated': // userName - userAvatarUrl
              if (this._currentUserData[payload.senderId]) {
                this._currentUserData[payload.senderId] = payload.data;
                this.model.onSocketUserDataChanged(payload.data);
              }
              break;

            case 'userDataChangeRequested':
              this.model.onSocketUserDataChangeRequested({
                sender: payload.sender,
                requestedUser: payload.data,
              });
              break;

            case 'userJoinGame':
              this.model.dispatchEvent({ type: GAME_EVENTS.NEW_VISITOR, data: payload });
              break;

            case 'updateGameUserStatus':
              this.model.dispatchEvent({ type: GAME_EVENTS.NEW_PLAYER_RECEIVED, data: payload });
              break;

            case 'updateGameStatus':
              this.model.dispatchEvent({ type: GAME_EVENTS.GAME_START, data: payload });
              break;

            case 'userLeftGame':
              this.model.dispatchEvent({ type: GAME_EVENTS.VISITOR_PLAYER_LEFT, data: payload });
              break;
            case GAME_EVENTS.VISITOR_TAKE_SEAT:
              this.model.dispatchEvent({ type: GAME_EVENTS.VISITOR_TAKE_SEAT, data: payload });
              break;

            case 'environmentChanged':
              if (payload.senderId != userProperties.userId) {
                this.model.config.worldId == payload.roomId && this.model.confirm($trans('confirm-room-data-changed'), () => { window.location.reload() });
              }
              break;

            case 'userChangedSeat':
              this._currentUserData.occupiedSeats = payload.occupiedSeats;
              this.model.setOccupiedSeat(payload, this._currentUserData);
              this.dispatchEvent({ type: SOCKET_EVENTS.USER_DATA_CHANGED, data: this._currentUserData });

              break;
            case 'userChangedScreenShareSeat':
              this._currentUserData.screenShareOccupiedSeats = payload.screenShareOccupiedSeats;
              this.model.setOccupiedScreenShareSeat(payload, this._currentUserData);
              this.dispatchEvent({ type: SOCKET_EVENTS.USER_CHANGED_SCREEN_SHARE_SEAT, data: this._currentUserData });
              break;
            case 'tour_userChangedScreenShareSeat':
              this._currentUserData.tour_screenShareOccupiedSeats = payload.tour_screenShareOccupiedSeats;
              this.model.tour_setOccupiedScreenShareSeat(payload, this._currentUserData);
              this.dispatchEvent({ type: SOCKET_EVENTS.TOUR_USER_CHANGED_SCREEN_SHARE_SEAT, data: this._currentUserData });
              break;
            case 'userLockRoom':
              if (payload.lockedRooms) {
                this._currentUserData.lockedRooms = payload.lockedRooms;
              }
              this.model.setLockedRooms(payload, this._currentUserData);
              break;
            case 'startRoomInvitation':
              this.model.onSendUserJoinRoomInvitation(payload);
              break;
            case 'chessInvite':
              this.model.onChessInvitation(payload);
              break;
            case 'sendChairInvite':
              this.model.onSendChairInvite(payload)
              break;
            case 'userChangedShowWebrtcInSeat':
              // $j('body').trigger('aptis-user-changed-show-webrtc-in-seat', [payload.userId, payload.seatId, payload.showInSeat]);
              break;
            case 'getUsersInfo':
              this.onlineFriends = payload.users;
              this.dispatchEvent({ type: SOCKET_EVENTS.ONLINE_FRIENDS_LOADED });
              break;
            case 'raiseHand':
              const d = this._currentUserData[payload.senderId];
              const { userName } = d;
              const message = `${userName} - raised hand`;
              this.model.info("success", message, { autoRemove: true })
              break;
            case 'guideModeOn':
              this.model.view.enabled = false;
              this.model.onTourInvitation(payload);
              break;
            case 'guideModeOff':
              if (payload.data?.id === this.model?.tourModeController?.tourData?.id) {
                tourMessages = [];
                this.model.view.enabled = true;
                this.model.onTourEnded();
                this.TOUR_userStandUp();
                this.disableGuidedCamera();
                this.model.dispatchEvent({ type: SCENE_EVENTS.GUIDE_MODE_OFF })
              }
              break;
            case 'acceptGuideMode':
              if (this.model.iAmGuide()) {
                const data = this._currentUserData[payload.senderId];
                if (this.model.pendingTourInvitations.get(String(payload.senderId)) === 'podium') {
                  this.model.markPodiumInviteAccepted(payload.senderId);
                }
                this.model.clearPendingTourInvitation(payload.senderId, null, { notify: false });
                if (data) {
                  this.model.info('success', `${data.userName} accepts tour mode`, { icon: ICON.JOIN });
                }
                this.model.dispatchEvent({ type: SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA });
              }
              break;
            case 'removeMeFromInviteList':
              if (this.model.iAmGuide()) {
                this.model.clearPendingTourInvitation(payload.senderId, 'guests');
              }
              break;
            case 'removeMeFromPodiumList':
              if (this.model.iAmGuide()) {
                this.model.markPodiumInviteDeclined(payload.senderId);
                this.model.clearPendingTourInvitation(payload.senderId, 'podium');
              }
              break;
            case 'inviteAsTourContributore':
              // this.model.tourContributeInvite(payload);
              break;
            case 'inviteAsTourGuest':
              this.model.onTourInvitation(payload, true);
              const guide = this._currentUserData[payload.senderId];
              const tourStarted = this.model.tourData[guide.userId];
              if (!tourStarted) {
                this.model.alert('success', `No tour found for ${guide.userName}`, { icon: ICON.JOIN });
              }
              if (payload.tour) {
                this.model.tourData[payload.tour.id] = payload.tour;
              }
              this.model.confirm(`${guide.userName} is inviting you to join tour - ${tourStarted.name}`, async () => {
                $(".tour-banner__icon").trigger('click');
                $(`button[data-id="${tourStarted.id}"]`).trigger('click');
              }, { dimmerClose: false, }, () => {
                this.socketTour.onRefuseTourInvitation(this.model.config.userId, payload.senderId, tourStarted.id);
              });
              break;
            case 'inviteToPodium':
            case 'tour-invite-to-podium':
              this.model.tourPodiumInvite(payload);
              break;
            case 'removedFromPodium':
              this.model.onRemovedFromPodium();
              break;
            case 'removedFromTour':
              this.model.onRemovedFromTour();
              break;
            case 'killTourGuestMode':
              if (payload.receiverId === this.model.config.userId) {
                this.model.onKillTourGuestMode();
              }
              break;
            case 'sendGlobalInvite':
              if (payload.invite) {
                ///redirect
                const callback = (payload) => {
                  window.location = window.location.protocol + "//" + window.location.host + "/worlds/view?" + payload.url + "&security=" + this.model.config.security
                }
                this.model.dispatchEvent({ type: SCENE_EVENTS.START_ANIMTAION_OUTRO, data: { onEndCallback: () => { callback(payload) } } })

              } else {
                this.model.dispatchEvent({ type: SCENE_EVENTS.GLOBAL_USER_JOIN_TOUR, payload })
              }
              break;
            case 'sendGlobalTourInvite':
              this.model.dispatchEvent({ type: SCENE_EVENTS.GLOBAL_USER_JOIN_WORLD_GLOBAL_INVITATAION, payload })
              break;
            case 'sendGlobalTourinvite':
              payload.url = window.location.protocol + "//" + window.location.host + "/worlds/view?" + payload.url + `tourId=${tourID}` + "&security=" + this.model.config.security;
              // payload.tourName = this.model.tourData[tourID].name;
              this.model.dispatchEvent({ type: SCENE_EVENTS.GLOBAL_USER_JOIN_WORLD_INVITATAION, payload })
              break;
            case 'tour-send-emoticon':
              if (payload.tourId === this.model.tourModeController?.tourData?.id) {
                this.model.dispatchEvent({ type: EMOTION_EVENTS.SHOW_AND_ANIMATE, payload })
              }
              break;
            case 'tour-update':
              this.socketTour.onTourUpdate(payload);
              break;
            case 'showNotification':
              let icon = '';
              switch (payload.icon) {
                case 'cancel':
                  icon = ICON.CANCEL;
                  break;
              }
              this.model.alert('success', payload.message, { icon });
              break;
            case 'tour-error':
              this.model.onTourEnded();
              this.model.alert('error', payload.message);
              break;
            case 'screenShareStreamRecieved':
              console.log('screenShareStreamRecieved', payload);
              this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.SCREEN_SHARE_STREAM_RECIEVED, data: payload });
              break;
            default:
              console.error("Unbekanntes Event", payload);
              break;
          }
        } catch (exception) {
          console.error('VRSocketManager._handleMessage()', exception, payload.eventName, payload);
        }
        this.dispatchEvent({ type: SOCKET_EVENTS.DATA_RECEIVED, data });
      });

      socket.on('webRtcData', (payload) => {
        this.dispatchEvent({ type: SOCKET_EVENTS.APTIS_WEB_RTC_DATA, data: payload });
        // $j('body').trigger('aptisWebRtcData', [payload]);
      });

      socket.on('gaming', (payload) => {
        this.dispatchEvent({ type: SOCKET_EVENTS.GAMING_DATA, data: payload });
      });

      socket.on('signalData', (payload) => {
        this.dispatchEvent({ type: SOCKET_EVENTS.APTIS_WEBRTC_SIGNAL, data: payload });
      });
      socket.on('error', () => {
        console.error('error', arguments);
      });
      socket.on('camera-update', (data) => {
        if (this.model.activeOneOnOneCall) {
          return;
        }
        if (data.userId === this.model.tourModeController?.tourData?.id) {
          // Use TourUpdateManager to handle incoming camera updates with smooth rendering
          if (this.tourUpdateManager) {
            this.cameraIsUpdating && this.tourUpdateManager.handleIncomingCameraUpdate(data, this.model, this.smoothCameraRenderer);
          }
        }
      });
      socket.on('pose-update', (data) => {
        if (data.userId === this.model.tourModeController.tourData.id) {
          this.updateAvatarPose(data.userId, data.pos, data.quat);
        }
      });

      _socket = socket;
      this.socket = socket;

      // Set socket reference for tour managers
      if (this.tourUpdateManager) {
        this.tourUpdateManager.setSocket(socket);
        this.tourUpdateManager.setUserId(this.model.config.userId);
      }
    }

    let timer = setInterval(function () {
      if (CONFIG) {
        clearInterval(timer);
        self.init(CONFIG);
        self.dispatchEvent({ type: SOCKET_EVENTS.SOCKET_READY, data: self });

      }
    }, 300);
    if (this.model.isEmbed === "0") {
      clearInterval(timer);
      timer = null;
    }
    this.customStart = () => {
      this.init(CONFIG);
      this.dispatchEvent({ type: SOCKET_EVENTS.SOCKET_READY, data: this });
    }

    //socket API
    this.filterBySocketIds = (arrSocketIds) => {
      return this.getUsers().filter(item => arrSocketIds.includes(item.socketId));
    };
    this.getSocket = () => { return socket };
    this.getGlobalActions = () => { return userProperties.actions };
    this.getUserData = () => { return userProperties };
    this.getUsers = () => {
      let objectsWithUserId = Object.entries(this._currentUserData).map(([key, value]) => {
        if (value && value.hasOwnProperty('userId')) {
          return value;
        }
      });
      objectsWithUserId = objectsWithUserId.filter(value => value !== undefined);
      return objectsWithUserId
    };
    this.getGuestUsers = () => {
      return this.getUsers().filter(user => user.isGuest)
    };
    this.getUserBySocketId = (socket_id) => {
      const users = this.getUsers();
      return users.find(user => user.socketId === socket_id);
    };
    this.getUsersObject = () => {
      const obj = {};
      for (const item of this.getUsers()) {
        if (item && item.userId) {
          obj[item.userId] = item;
        }
      }
      return obj;
    };
    this.getAllOnlineUsersObject = () => {
      const { model: { friends } } = this;
      const obj = {};
      if (friends && friends.online) {
        friends.online.forEach(friend => {
          obj[friend.userId] = friend;
        });
      }
      for (const item of this.getUsers()) {
        if (item && item.userId) {
          obj[item.userId] = item;
        }
      }
      return obj;
    };
    this.getOnlineFriends = () => { return this.onlineFriends };
    this.iSitOnChair = () => {
      return this.getOccupiedSeats()[userProperties.userId]
    };
    this.getOccupiedSeats = () => {
      if (this._currentUserData.occupiedSeats) {
        return this._currentUserData.occupiedSeats
      } else {
        return {}
      }
    };
    this.getOccupiedSeatsAsArray = () => {
      return Object.values(this.getOccupiedSeats())
    }
    this.getOccupiedScreenShareSeats = () => {
      if (this._currentUserData.screenShareOccupiedSeats) {
        return this._currentUserData.screenShareOccupiedSeats
      } else {
        return {}
      }
    };
    this.getTourOccupiedScreenShareSeats = () => {
      if (this._currentUserData.tour_screenShareOccupiedSeats) {
        return this._currentUserData.tour_screenShareOccupiedSeats
      } else {
        return {}
      }
    };
    this.getOnlineUsers = () => {
      let users = this.getUsers();
      const tourGuests = [];
      users.forEach(item => {
        if (item && item.tourGuest) {
          tourGuests.push(item)
        }
      })
      return users;
    };
    this.getUsersWhoStream = () => {
      let _data = this.getUsersObject();
      const users = [];
      Object.keys(_data).forEach(key => {
        if (_data[key] && _data[key].userId) {
          if (_data[key].webcamStreamId) {
            users.push(_data[key])
          }
          if (_data[key].screenShareStreamId) {
            users.push(_data[key])
          }
        }
      })
      return users
    };
    this.getUsersWhoStreamOnlyOneAdapter = () => {
      let _data = this.getUsersObject();
      const users = [];
      Object.keys(_data).forEach(key => {
        if (_data[key] && _data[key].userId) {
          if (_data[key].webcamStreamId && !_data[key].screenShareStreamId) {
            users.push(_data[key])
          }
          if (_data[key].screenShareStreamId && !_data[key].webcamStreamId) {
            users.push(_data[key])
          }
        }
      })
      return users
    };
    this.getUsersWhoStreamCameraAndScreen = () => {
      let _data = this.getUsersObject();
      const users = [];
      Object.keys(_data).forEach(key => {
        if (_data[key] && _data[key].userId) {
          if (_data[key].webcamStreamId && _data[key].screenShareStreamId) {
            users.push(_data[key])
          }
        }
      })
      return users
    };
    this.isUserOnline = (id) => this._currentUserData[id];
    this.getUsersOnOccupiedSeats = () => {
      let occupiedSeats = this._currentUserData.occupiedSeats;
      let seatId;
      let result = [];
      if (!occupiedSeats) {
        return []
      }
      for (const key in occupiedSeats) {
        if (occupiedSeats[key] !== null) {
          seatId = key;
          result.push(occupiedSeats[key]);
        }
      }
      return result
    };

    this.getUserWebcamData = (streamId) => {
      let arrOfUsers = this.getUsersOnOccupiedSeats();
      let userData = this._currentUserData;
      let result = null;
      arrOfUsers.forEach(user => {
        if (userData[user].webcamStreamId == streamId) {
          result = userData[user];
        }
      });
      return result;
    };
    this.getUsersOnOccupiedScreens = () => {
      let occupiedScreens = this._currentUserData.occupiedScreens;
      let seatId;
      let result = [];
      if (!occupiedScreens) {
        return [];
      }
      for (const key in occupiedScreens) {
        if (occupiedScreens[key] !== null) {
          seatId = key;
          result.push(occupiedScreens[key]);
        }
      }
      return result
    };
    this.isScreenObjIdOccupied = (objId) => {
      let occupiedScreens = this._currentUserData.occupiedScreens;
      let result = false;
      for (const key in occupiedScreens) {
        if (key == objId) {

          if (occupiedScreens[key] !== null) {
            result = true;
          }
        }
      }
      return result
    };
    this.getUserScreenData = (streamId) => {
      let arrOfUsers = this.getUsersOnOccupiedScreens();
      let userData = this._currentUserData;
      let result = null;
      arrOfUsers.forEach(user => {
        if (userData[user].screenStreamId == streamId) {
          result = userData[user];
        }
      });
      return result;
    };
    this.isAnyoneStreaming = () => {
      let usersOnOccupiedScreens = this.getUsersOnOccupiedScreens();
      let usersOnOccupiedSeats = this.getUsersOnOccupiedSeats();
      return usersOnOccupiedScreens.length > 0 || usersOnOccupiedSeats.length > 0;
    };
    this.isUserOnChair = (id) => {
      let usersOnOccupiedSeats = this.getUsersOnOccupiedSeats();
      return usersOnOccupiedSeats.filter(item => item == id).length > 0;
    };

    this.sendMessage = this.onSendMessage;
    model.getUserData = this.getUserData;
    model.getUsers = this.getUsers;
    model.onSendPrivateRequest = this.onSendPrivateRequest;
    model.onAcceptPrivateRequest = this.onAcceptPrivateRequest;
    // this.addUserMessage = this.addUserMessage;
  }

  ///API

  getSocketConfig = () => (this._config);
  getMessages = () => (allUsermessages);

  onSendMessage = (message, receiverId, type) => {
    if (!message) {
      return;
    }
    let image = this.model.sceneData.previewBackgroundImage.mediumPath;
    if (type === "local") {
      image = getImgThumb(this.model.currentScene.background.mediumPath);
    }
    const messagePayload = {
      eventName: 'chatMessage',
      text: message,
      senderId: userProperties.userId,
      senderName: userProperties.userName,
      senderAvatarUrl: userProperties.userAvatarUrl,
      receiverId,
      sceneId: this.model.currentScene.id,
      receiverName: userProperties.userName,
      receiverType: type ? type : 'room',
      time: new Date().toISOString(),
      image,
    };
    if (_socket) {
      _socket.emit('message', messagePayload);
    }
    if (type === "local") {
      image = getImgThumb(this.model.currentScene.background.mediumPath);
      addLocalMessage(messagePayload, "sent");
      this.dispatchEvent({ type: SOCKET_EVENTS.LOCAL_MESSAGE_RECEIEVED, messagePayload });
    }
    if (type === "chess") {
      addChessMessage(messagePayload, "sent");
      this.dispatchEvent({ type: SOCKET_EVENTS.CHESS_MESSAGE_RECEIVED, messagePayload });
    }
  }

  onSendMessagePvt = ({ message, userName, userId, toSave }) => {
    if (!message) {
      return;
    }
    const messagePayload = {
      eventName: 'chatMessage',
      text: message,
      senderId: userProperties.userId,
      senderName: userProperties.userName,
      senderAvatarUrl: userProperties.userAvatarUrl,
      receiverId: userId,
      sceneId: this.model.currentScene.id,
      receiverName: userName,
      receiverType: 'user',
      time: new Date().toISOString(),
      image: this.getUserData()["userAvatarUrl"]
    };
    if (_socket) {
      addPrivateMessage(messagePayload, "sent", toSave);
      this.dispatchEvent({ type: SOCKET_EVENTS.USER_ONE_ON_ONE_SENT, messagePayload });
      _socket.emit('message', messagePayload);
    }
  }
  onSendOfflinePvt = ({ message, userName, userId }) => {
    if (!message) {
      return;
    }
    const messagePayload = {
      eventName: 'chatOfflineMessage',
      text: message,
      senderId: userProperties.userId,
      senderName: userProperties.userName,
      senderAvatarUrl: userProperties.userAvatarUrl,
      receiverId: userId,
      sceneId: this.model.currentScene.id,
      receiverName: userName,
      receiverType: 'user',
      time: new Date().toISOString(),
    };
    if (_socket) {
      _socket.emit('message', messagePayload);
    }
  }
  addUserMessage = (message, oneOnOne = false, data = null) => {
    if (!message) {
      return;
    }
    const messagePayload = {
      eventName: 'chatMessage',
      text: message,
      senderId: userProperties.userId,
      senderName: userProperties.userName,
      senderAvatarUrl: userProperties.userAvatarUrl,
      receiverId: userProperties.userId,
      receiverName: userProperties.userName,
      receiverType: !oneOnOne ? 'room' : 'user',
      time: new Date().toISOString(),
    };
    if (oneOnOne) {
      const id = data ? data.userId : null;
      messagePayload.senderId = id;
      addPrivateMessage(messagePayload, "sent");
      // this.dispatchEvent({ type: SOCKET_EVENTS.ONE_ONE_ONE_MESSAGE_RECEIVED, data: { messages: allUsermessages[id] } });
      this.dispatchEvent({ type: SOCKET_EVENTS.USER_ONE_ON_ONE_SENT, data: { messages: allUsermessages[id] } });

    } else {
      messages.push({ sent: messagePayload });
      addGlobalMessage(messagePayload, "sent");
      this.dispatchEvent({ type: SOCKET_EVENTS.GLOBAL_MESSAGE_SENT, data: { messages } });
    }
  }

  onSendPrivateRequest = ({ message, userName, userId, wantedSceneId }) => {
    if (!message) {
      return;
    }
    const messagePayload = {
      eventName: 'chatMessage',
      text: message,
      wantedSceneId: wantedSceneId,
      senderId: userProperties.userId,
      senderName: userProperties.userName,
      senderAvatarUrl: userProperties.userAvatarUrl,
      receiverId: userId,
      receiverName: userName,
      receiverType: 'lockRequest', ///TODO :: Add constants
      time: new Date().getTime(),
    };
    if (_socket) {
      _socket.emit('message', messagePayload);
    }
  }
  onAcceptPrivateRequest = ({ message, userName, userId, approve }) => {
    const messagePayload = {
      eventName: 'chatMessage',
      text: message,
      senderId: userProperties.userId,
      senderName: userProperties.userName,
      senderAvatarUrl: userProperties.userAvatarUrl,
      receiverId: userId,
      receiverName: userName,
      wantedSceneId: userProperties.sceneId,
      approve: approve,
      receiverType: 'acceptLockRequest', ///TODO :: Add constants
      time: new Date().getTime(),
    };
    if (_socket) {
      _socket.emit('message', messagePayload);
    }
  }

  updateUserData = (newUserData) => {
    this._send({
      eventName: 'updateUserData',
      senderId: userProperties.userId,
      data: newUserData,
    });
  }

  requestUpdateUserData = (targetUserId, newUserData) => {
    this._send({
      eventName: 'requestUpdateUserData',
      senderId: userProperties.userId,
      data: {
        targetUserId,
        newUserData,
      },
    })
  }

  userStartedWebRTCStream = (newUserData) => {
    this._send({
      eventName: 'updateUserData',
      senderId: userProperties.userId,
      data: newUserData,
    });
  }
  userToggleCamera = (e) => {
    userProperties.userVideoOn = this.model.userWantsCamera;
    // userProperties.on1on1Call = e.data.on1on1Call;
    if (this._currentUserData[userProperties.userId]) {
      this._currentUserData[userProperties.userId].userVideoOn = userProperties.userVideoOn;
      // this._currentUserData[userProperties.userId].on1on1Call = e.data.on1on1Call;
    }
    this._send({
      eventName: 'userVideoStateChanged',
      senderId: userProperties.userId,
      data: {
        userVideoOn: userProperties.userVideoOn,
        ...(this.model.webcamStreamId && { webcamStreamId: this.model.webcamStreamId }),
      }
    });
  }
  userToggleMicrophone = (e) => {
    userProperties.userMicOn = this.model.userWantsAudio;
    // userProperties.on1on1Call = e.data.on1on1Call;
    if (this._currentUserData[userProperties.userId]) {
      this._currentUserData[userProperties.userId].userMicOn = userProperties.userMicOn;
      // this._currentUserData[userProperties.userId].on1on1Call = e.data.on1on1Call;
    }
    this._send({
      eventName: 'userMicrophoneStateChanged',
      senderId: userProperties.userId,
      data: {
        userMicOn: userProperties.userMicOn,
        // on1on1Call: userProperties.on1on1Call,
      },
    });
  }
  _send = (payload, eventName = 'message') => {
    _socket && _socket.emit(eventName, payload);
  }

  _joinScene = (sceneId, sceneName) => {
    this._send({
      eventName: 'sceneJoined',
      senderId: userProperties.userId,
      data: {
        sceneId: sceneId,
        sceneName: sceneName,
      },
    });

  }
  _userChangingSeat = (userId, newSeatId, streamId) => {
    const data = {};
    userId = userId || userProperties.userId;
    this._send({
      eventName: 'userChangingSeat',
      userId: userId,
      seatId: newSeatId,
    });
  };
  TOUR_userChangingScreenShareSeat = (newSeatId, streamId) => {
    this._send({
      eventName: 'updateUserData',
      senderId: userProperties.userId,
      data: { tourContributore: streamId },
    });
    this._send({
      eventName: 'tour_userChangingScreenShareSeat',
      userId: userProperties.userId,
      seatId: newSeatId,
    });
  };

  _userChangingScreenShareSeat = (userId, newSeatId, streamId) => {
    const data = {};
    userId = userId || userProperties.userId;
    this._send({
      eventName: 'userChangingScreenShareSeat',
      userId: userId,
      seatId: newSeatId,
    });
  };

  TOUR_userStandUp = () => {
    this._send({
      eventName: 'updateUserData',
      senderId: userProperties.userId,
      data: { tourContributore: null },
    });
    this._send({
      eventName: 'tour_userChangingScreenShareSeat',
      seatId: '0',
      userId: userProperties.userId,
    });
  };
  _userChangingScreen = (userId, newScreenId, screenStreamId) => {
    const data = {};
    data.screenStreamId = screenStreamId;
    this.updateUserData(data);
    this._send({
      eventName: 'userChangingScreen',
      userId: userId,
      screenId: newScreenId,
      streamId: screenStreamId
    });
  };

  _userLockingRoom = (userId, newSceneId) => {
    userId = userId || userProperties.userId;
    this._send({
      eventName: 'userLockingRoom',
      userId: userId,
      sceneId: newSceneId,
    });
  };

  _inviteUserToRoom = (receiverId, wantedSceneId) => {
    this._send({
      eventName: 'startRoomInvitation',
      wantedSceneId,
      receiverId,
      senderId: userProperties.userId,
    });
  };
  inviteToChessGame = (receiverId, gameId, seatId = null) => {
    this._send({
      eventName: 'chessInvite',
      senderId: userProperties.userId,
      receiverId,
      sceneId: this.getUsersObject()[this.model.config.userId].currentSceneId,
      worldId: this.model.config.worldId,
      gameId,
      ...(seatId && { seatId })
    });
  };
  inviteGlobalTour = (receiverId, wantedSceneId, tourData) => {
    this._send({
      eventName: 'sendGlobalTourInvite',
      wantedSceneId,
      receiverId,
      tourData,
      senderId: userProperties.userId,
      sender: this.getUserData(),
    });
  };

  _requestChatHistory = (senderId, success, page = 0, perPage = 50) => {
    this.model.chatFetcher.getPrivateMessages(senderId, page, perPage, (response) => {
      if (success && typeof success === "function") {
        success(response);
      }
      this.dispatchEvent({ type: SOCKET_EVENTS.CHAT_HISTORY_LOADED, data: response.data });
    })
  }

  // REMOVE NOTIFICATION
  _removeNotification = (classToBeRemoved) => {
    $(`.${classToBeRemoved}`).remove();
    const activeCalls = $("#video_notifications > .call_notification").length;
    $('#notification_toggle_button').attr('data-count', activeCalls);
    if (!activeCalls) {
      $('#notifications_holder').removeClass('expanded');
      $('#notification_toggle_button').hide();
    }
  };
  sendMessageNotification = (message) => {
    this._send({
      eventName: 'userLockingRoom',
      userId: userProperties.userId,
      text: message
    });
  }
  requestFriendsInfo = (friendsIds) => {
    this._send({
      eventName: 'getUsersInfo',
      userIds: friendsIds,
      senderId: userProperties.userId,
    });
    // this.dispatchEvent({ type: SOCKET_EVENTS.FRIENDS_LIST_LOADED });
  }
  sendGlobalInvite = (receiverId, invite = false) => {
    this._send({
      eventName: 'sendGlobalInvite',
      invite,
      senderId: userProperties.userId,
      receiverId,
    });
    // this.dispatchEvent({ type: SOCKET_EVENTS.FRIENDS_LIST_LOADED });
  }
  on = (name, callback) => {
    this.callbacks.push({ id: name, func: callback });
  }
  onStartGuideMode = (values) => {
    const { componentValue, inputValue } = values;
    this.deltaUpdateManager.reset();

    this._send({
      eventName: 'updateUserData',
      senderId: userProperties.userId,
      data: { guide: this.model.publishStreamId, tourName: inputValue },
    });

    this._send({
      eventName: 'guideModeOn',
      senderId: userProperties.userId,
      componentValue,
      inputValue
    });

    // NEW: Optimized camera update method with throttling and delta
    this.updateCameraData = () => {
      if (this.model.activeOneOnOneCall) {
        return;
      }
      const position = this.model.camera.position;
      const rotation = this.model.camera.rotation;
      const fov = this.model.camera.fov;


      // Use delta-based updates to reduce unnecessary transmissions
      this.tourUpdateManager.updateCamera(position, rotation, fov, this.mouseData);
    }

    this.socketTour.onTourStart(componentValue, inputValue, this.model.publishStreamId, values.visibility);

    // Update at 60fps but throttled internally to 15Hz
    const intervalMs = 1000 / 60; // 60 fps check rate
    this.tourInterval = setInterval(this.updateCameraData, intervalMs);
  }
  onStopGuideMode = () => {
    this.tourInterval && clearInterval(this.tourInterval)
    this._send({
      eventName: 'updateUserData',
      senderId: userProperties.userId,
      data: { guide: null, tourName: null },
    });
    this._send({
      eventName: 'guideModeOff',
    });
    // Cleanup any ongoing guided camera/smoothing
    this.disableGuidedCamera();
    try { this.tourUpdateManager?.stopSmoothing?.(); } catch (e) { }
    try { this.smoothCameraRenderer?.stop?.(); } catch (e) { }
    const cursor = $("#follow-cursor");
    if (cursor && cursor.length) { cursor.hide(); }
  }
  acceptGuideMode = (tour) => {
    const resolved = tour?.id ? (this.model.tourData[tour.id] || tour) : null;
    if (this.model.refuseOneToOneJoin(resolved)) {
      this.model.info('info', $trans('one-to-one-tour-closed'));
      return false;
    }
    this._send({
      eventName: 'acceptGuideMode',
      tourId: tour.id,
      senderId: userProperties.userId,
    });
    this._send({
      eventName: 'updateUserData',
      senderId: userProperties.userId,
      data: { tourName: tour.name },
    });
    this.socketTour.onTourAcceptInvite(tour.id);

    // In acceptGuideMode method, add:
    if (!this.model.tourContributore) {
      this.enableGuidedCamera();
      this.smoothCameraRenderer.start(); // Start smooth rendering
    }
  }
  sendRaiseHand = () => {
    this._send({
      eventName: 'updateUserData',
      senderId: userProperties.userId,
      data: { raisedHand: true },
    });
    this._send({
      eventName: 'raiseHand',
      senderId: userProperties.userId,
    });
    this.socketTour.onRaiseHand();
  }

  onGuidedCamera = (payload) => {
    // Handle guidedCamera events (legacy format)
    const cursor = $("#follow-cursor");
    if (cursor[0] && payload.mouse) {
      const normalizedX = payload.mouse.x;
      const normalizedY = payload.mouse.y;

      // Calculate the position based on the screen size of the other screen
      const otherScreenWidth = window.innerWidth;
      const otherScreenHeight = window.innerHeight;
      const posX = normalizedX * otherScreenWidth;
      const posY = normalizedY * otherScreenHeight;

      // Set the position of the cursor element
      cursor[0].style.left = posX + 'px';
      cursor[0].style.top = posY + 'px';

      cursor.show();
    }

    // Validate values before applying
    const isValidNumber = (value) => typeof value === 'number' && isFinite(value);

    if (payload.position &&
      isValidNumber(payload.position.x) &&
      isValidNumber(payload.position.y) &&
      isValidNumber(payload.position.z)) {
      this.model.camera.position.x = payload.position.x;
      this.model.camera.position.y = payload.position.y;
      this.model.camera.position.z = payload.position.z;
    }

    if (payload.rotation &&
      isValidNumber(payload.rotation.x) &&
      isValidNumber(payload.rotation.y) &&
      isValidNumber(payload.rotation.z)) {
      this.model.camera.position.clone().add(payload.rotation);
    }

    if (payload.zoom !== undefined && isValidNumber(payload.zoom)) {
      this.model.camera.fov = payload.zoom;
    }

    this.model.view.controls.update();
    this.model.camera.updateProjectionMatrix();
    this.model.view.updateShphereTextureOnMove();
  }
  enableGuidedCamera = () => {
    if (this.cameraIsUpdating)
      return;
    this.cameraIsUpdating = true;
    this.model.view.controls.enabled = false;
    _socket.on('guidedCamera', this.onGuidedCamera)
  }
  disableGuidedCamera = () => {
    this.cameraIsUpdating = false;
    this.model.view.controls.enabled = true;
    _socket.off('guidedCamera', this.onGuidedCamera);
    this.smoothCameraRenderer.stop();
    // Ensure smoother is stopped and cursor hidden
    try { this.tourUpdateManager?.stopSmoothing?.(); } catch (e) { }
    const cursor = $("#follow-cursor");
    if (cursor && cursor.length) { cursor.hide(); }
  }
  inviteAsTourContributore = (receiverId) => {
    const user = this.getOnlineUsers().filter(user => user.userId === receiverId);
    if (!user[0])
      return;
    this.socketTour.sendContributoreInvite(receiverId)
  }
  inviteAsTourGuest = (receiverId, socketId, tour) => {
    const activeTour = tour || this.model.iAmInTour();
    if (this.model.isOneToOneTour(activeTour)) {
      this.model.info('info', $trans('one-to-one-tour-closed'));
      return;
    }
    this._send({
      eventName: 'inviteAsTourGuest',
      senderId: userProperties.userId,
      recieverSocketId: socketId,
      receiverId: receiverId,
      tourId: tour.id,
    })
  }
  inviteToPodium = (receiverId, socketId, tour) => {
    this._send({
      eventName: 'inviteToPodium',
      senderId: userProperties.userId,
      recieverSocketId: socketId,
      receiverId: receiverId,
      tourId: tour.id,
    })
  }
  removeUserFromPodium = (user, tour) => {
    if (!user || !tour) {
      return;
    }
    this._send({
      eventName: 'removeUserFromPodium',
      senderId: userProperties.userId,
      recieverSocketId: user.socketId,
      receiverId: user.userId,
      tourId: tour.id,
    })
  }
  removeUserFromTour = (user, tour) => {
    if (!user || !tour) {
      return;
    }
    this._send({
      eventName: 'removeUserFromTour',
      senderId: userProperties.userId,
      recieverSocketId: user.socketId,
      receiverId: user.userId,
      tourId: tour.id,
    })
  }
  answerAsTourGuest = () => {
    this._send({
      eventName: 'updateUserData',
      senderId: userProperties.userId,
      data: { raisedHand: null },
    });
  }
  acceptTourGuestMode = (publishStreamId) => {
    this._send({
      eventName: 'updateUserData',
      senderId: userProperties.userId,
      data: { tourGuest: publishStreamId },
    });
    const tourStarted = this.model.iAmInTour();
    if (tourStarted) {
      this.socketTour.acceptPodium(tourStarted.id);
    }
  }
  killTourGuestMode = (receiverId) => {
    this._send({
      eventName: 'killTourGuestMode',
      senderId: userProperties.userId,
      receiverId: receiverId,
    });

    this.socketTour.onStopGuestMode(receiverId);
  }

  sendUserAudioLevelChanged = (audioLevels) => {
    this._send({
      eventName: 'userAudioLevelsChanged',
      senderId: userProperties.userId,
      data: {
        newAudioLevels: audioLevels,
      },
    });
  }

  sendChairInvite = (data) => {
    this._send({
      eventName: 'sendChairInvite',
      senderId: userProperties.userId,
      receiverId: data.userId,
      obj_id: data.obj_id,
    });
  }
  updateOneOnOneStatus = (status) => {
    this._send({
      eventName: 'userVideoStateChanged',
      senderId: userProperties.userId,
      data: { ...status }
    });
  }
  sendNotificationToUser = (receiverId, message, { icon = '' } = {}) => {
    this._send({
      eventName: 'showNotification',
      senderId: userProperties.userId,
      receiverId: receiverId,
      message: message,
      icon,
    });
  }

  cleanUpData() {
    console.log('clean up')
    this._currentUserData = {}
    this.onlineFriends = []
  }

  disconnect = async () => {
    if (_socket?.connected) {
      await _socket.disconnect();
    }
    if (socket?.connected) {
      await socket.disconnect();
    }
    if (this.socket?.connected) {
      await this.socket.disconnect();
    }
  }
  forceDisconnect = async () => {
    this.forcedReload = true;
    await this.disconnect();
    _socket?.removeAllListeners();
    _socket = null;
  }
  reset = () => {
    this._currentUserData = {};
  }

  updateAvatarPose = (userId, position, quaternion) => {
    // Update avatar position and rotation for the specified user
    // This integrates with your existing avatar system
    const userData = this._currentUserData[userId];
    if (userData && this.model.updateUserAvatar) {
      this.model.updateUserAvatar(userId, {
        position: position,
        quaternion: quaternion
      });
    }
  }

  /**
   * Waits for the socket to be available and have data
   * @param {number} timeout - Timeout in milliseconds before retrying
   * @param {number} maxAttempts - Maximum number of attempts before giving up
   * @returns {Promise<any>} - The socket object when available
   */
  async getSocketWhenReady(timeout = 300, maxAttempts = 100) {
    // Keep track of attempts to avoid infinite recursion
    let attempts = 0;

    // Inner recursive function
    const checkSocket = async () => {
      attempts++;

      // Get the current socket
      const socket = this.getSocket();

      // If socket exists and has data, return it
      if (socket && socket.connected) {
        return socket;
      }

      // If we've exceeded max attempts, throw an error
      if (attempts >= maxAttempts) {
        throw new Error(`Socket not available after ${maxAttempts} attempts`);
      }

      // Wait for the specified timeout
      await new Promise(resolve => setTimeout(resolve, timeout));

      // Try again recursively
      return checkSocket();
    };

    // Start the recursive check
    return checkSocket();
  }
  isAnybodyStreaming() {
    return this._currentUserData.screenShareOccupiedSeats
      ? (Object.values(this._currentUserData.screenShareOccupiedSeats).find(v => v !== null) || false)
      : false;
  }
  onScreenShareStreamRecieved = (id) => {
    this._send({
      eventName: 'screenShareStreamRecieved',
      senderId: userProperties.userId,
      id: id,
    });
  }
}

export { Socket, WEBRTC_EVENTS }
